<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-8 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <p class="text-justify intro-text">
                  <span>سلام علیکم</span><br>
                  <span>
                    شما فرهیخته گرامی، به عنوان فردی مورد تایید (با این شماره تلفن گوشی همراه) از طریق یکی از نهادهای مورد تایید نیروی انتظامی جهت دریافت نرم افزار سامانه برخط ناظر یک معرفی شده اید.
                  </span><br>
                  <span>
                  سامانه برخط ناظر یک؛ یک نرم افزار موبایلی است که جهت  ثبت کشف حجاب در ماشین می باشد که زیر نظر پلیس امنیت عمومی نیروی انتظامی جمهوری اسلامی می باشد.
                  </span><br>
                  <span>
                  در این سامانه ثبت نام، ابتدا سامانه ناظر یک به شما معرفی میگردد.
                  </span><br>
                  <span>
                  پس از اطلاع اجمالی شما از عملکرد این سامانه، در صورت درخواست شما برای همکاری با این سامانه،  ثبت نام اولیه را انجام داده و وارد مرحله بعد خواهید شد.
                  </span><br>
                  <span>
                  در مرحله بعد، نحوه کار کردن با این سامانه به شما آموزش داده و سپس از شما آزمونی گرفته خواهد شد.
                  </span><br>
                  <span>
                  سپس مدارک درخواستی را پر کنید و بعد از آن منتظر خبر پلیس امنیت عمومی جهت راه اندازی نرم افزار سامانه برخط ناظر یک بر روی گوشی موبایلتان باشید.
                  </span><br>
                  <span>
                  این خبر با ارسال پیامک لینک نرم افزاربه شماره تلفن شما جهت نصب نرم افزار ناظر یک انجام خواهد شد.
                  </span><br>
                  <span>
                  نکات:
                  </span><br>
                  <span>
                  اول: درصورتی که سن شما کمتر از 19سال می باشد، ثبت نام را ادامه ندهید، و درصورت ثبت نام، دعوت به همکاری از شما انجام نخواهد شد.
                  </span><br>
                  <span>
                  دوم: توجه داشته باشید که در صورت عدم کسب امتیاز لازم در آزمون و یا تشخیص مشکلی در مدارک ارسالی، این دعوت به همکاری انجام نخواهد شد.
                  </span><br>
                  <span>
                  سوم: در صورت تایید جنابعالی جهت همکاری، امکان دارد ارسال پیامک دعوت به همکاری تا یک ماه زمان ببرد.
                  </span><br>
                  <span>
                  در ادامه توضیحات تکمیلی سامانه برخط  ناظر یک و ثبت نام در آن :
                  </span><br>
                  <span class="fw-bold">
                  توضیح:
                  </span><br>
                  <span>
                  جهت ادامه توضیحات در این سامانه ثبت نام و دیدن بقیه صفحات، کلیک (صفحه بعد) را  که در پایین همه صفحات می باشد، بزنید.
                  </span><br>
                </p>
                <RouterLink to="/introSecond" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.intro-text{
  font-family: Calibri,sans-serif;
}
</style>
<script>
/*import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}*/

</script>
